(function($, Drupal, once, cookies) {

    //copy raf code from url and save in clipboard
    Drupal.behaviors.trackCodeHandler = {
        attach: function(context, settings) {
            once('trackCodeHandler', 'html', context).forEach(function(element) {
                $(document).ready(function() {

                    let params = new URLSearchParams();

                    // handle referral code
                    handleRafCode(params);
                    // handle channel code
                    handleChannelCode(params);
                    // handle source code
                    handleSourceCode(params, cookies);
                    // handle click id
                    handleClickID(params);

                    // prepare text for clipboard
                    if (params.toString().length > 0) {
                        new ClipboardJS('a', {
                            text: function(trigger) {
                                return decodeURIComponent(params.toString());
                            }
                        });
                        let upURL = ( $(".user_portal_url").attr('href') != null) ? $(".user_portal_url").attr('href') : "https://u.ahagame.com.cn";
                        let redirectURL = upURL + "/node-list?download=ios&popup=outline" + "&" + params.toString();
                        $(".ios-up-redirect").each(function() {
                            $(this).attr("href", redirectURL);
                        });
                    }
                });
            })
        }
    };

    Drupal.behaviors.twitterTracker = {
        attach: function (context, settings) {
            once('twitterXadTracker', '.twitter-xad1-tracker', context).forEach(function (element) {
                $(element).on('click', function (e) {
                  // Fire the Twitter tracking event.
                  if (typeof twq === 'function') {
                    twq('event', 'tw-oyop3-oyop6', {});
                  }
        
                  // Allow link navigation after a slight delay.
                  const href = $(this).attr('href');
                  if (href) {
                    e.preventDefault(); // Prevent immediate navigation.
                    setTimeout(function () {
                      window.location.href = href;
                    }, 200); // Delay navigation by 200ms to ensure the event is fired.
                  }
                });
              });
        }
    }


    //Enable popover (overrides the one theme behavior of the same name)
    Drupal.behaviors.popover = {
        attach: function (context, settings) {
            once('popover', 'html', context).forEach(function (element) {
                $(document).ready(function () {
                    if (!isMobile()) {
                        //Drupal.t doesnt work somehow, this is a workaround
                        let title = drupalSettings.path.currentLanguage == "zh-hans" ? "请用手机相机或浏览器扫码" : Drupal.t('Use camera or browser to scan');
                        let androidApp = drupalSettings.path.currentLanguage == "zh-hans" ? "安卓App" : Drupal.t('Android App');
                        //qrcode is generated from the button's href on hover (so params added by
                        //copy-url-params are included); buttons without an http(s) href get no popover.
                        //the platform icon (images/qr-ios.png / qr-android.png) is drawn in the middle
                        let qrWithLogo = function (text, logo) {
                            let qr = qrcode(0, 'H');
                            qr.addData(text);
                            qr.make();
                            let count = qr.getModuleCount(), cell = 8, margin = cell * 2;
                            let size = count * cell + margin * 2;
                            let canvas = document.createElement('canvas');
                            canvas.width = canvas.height = size;
                            let ctx = canvas.getContext('2d');
                            ctx.fillStyle = '#fff';
                            ctx.fillRect(0, 0, size, size);
                            ctx.fillStyle = '#000';
                            for (let r = 0; r < count; r++) {
                                for (let c = 0; c < count; c++) {
                                    if (qr.isDark(r, c)) {
                                        ctx.fillRect(margin + c * cell, margin + r * cell, cell, cell);
                                    }
                                }
                            }
                            //logo covers ~24% of the width, well within level H's 30% error correction
                            let logoSize = Math.round(count * cell * 0.24), pad = cell / 2;
                            let x = (size - logoSize) / 2;
                            ctx.fillStyle = '#fff';
                            ctx.fillRect(x - pad, x - pad, logoSize + pad * 2, logoSize + pad * 2);
                            ctx.drawImage(logo, x, x, logoSize, logoSize);
                            return canvas.toDataURL('image/png');
                        };
                        let qrSrc = function (el, logo) {
                            if (/^https?:/i.test(el.href) && typeof qrcode === 'function') {
                                if (logo.complete && logo.naturalWidth) {
                                    try {
                                        return qrWithLogo(el.href, logo);
                                    } catch (e) {
                                        //canvas unavailable, use the plain qrcode
                                    }
                                }
                                let qr = qrcode(0, 'M');
                                qr.addData(el.href);
                                qr.make();
                                return qr.createDataURL(6, 12);
                            }
                        };
                        let bindQrPopover = function (selector, logoFile, label) {
                            let logo = new Image();
                            if ($(selector).length > 0) {
                                logo.src = '/themes/custom/ahaspeed/images/' + logoFile;
                            }
                            $(selector).each(function () {
                                let el = this;
                                if (!qrSrc(el, logo)) {
                                    return;
                                }
                                $(el).popover({
                                    trigger: 'hover',
                                    html: true,
                                    content: function () {
                                        return '<img class="img-fluid" src="' + qrSrc(el, logo) + '" /><p class="text-center">' + label + '</p>';
                                    },
                                    title: title,
                                    placement: 'top'
                                })
                            });
                        };
                        bindQrPopover('.ios-dl-url.popover-qrcode', 'qr-ios.png', 'iOS App');
                        bindQrPopover('.android-dl-url.popover-qrcode', 'qr-android.png', androidApp);
                    }
                });
            })
        }
    };

})(jQuery, Drupal, once, window.Cookies);